import { mutatorAction } from 'satcheljs';
import store from 'owa-domain-option/lib/store/store';

export default mutatorAction('setSafeLinksOption', function setSafeLinksOption(newValue: boolean) {
    store.userInfo.safeLinksEnabled = newValue;
});
